(function () {
  if (window.__scrollAnimationsInit) return;
  window.__scrollAnimationsInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-revealed', 'is-anim-done');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-animate-delay') || '0', 10);
      if (delay > 0) {
        el.style.setProperty('--anim-delay', delay + 'ms');
      }
      el.classList.add('is-revealed');
      var done = function (e) {
        if (e && e.target !== el) return;
        el.classList.add('is-anim-done');
        el.removeEventListener('transitionend', done);
      };
      el.addEventListener('transitionend', done);
      setTimeout(done, 1200);
      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  function applyStagger(parent) {
    var step = parseInt(parent.getAttribute('data-animate-stagger') || '80', 10);
    var base = parseInt(parent.getAttribute('data-animate-stagger-base') || '0', 10);
    var children = parent.children;
    var idx = 0;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (!child.hasAttribute('data-animate')) continue;
      if (child.hasAttribute('data-animate-delay')) { idx++; continue; }
      child.setAttribute('data-animate-delay', base + (idx * step));
      idx++;
    }
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-animate-stagger]').forEach(applyStagger);
    scope.querySelectorAll('[data-animate]').forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
